import {EnvelopeIcon, LockIcon} from "assets/icons";
import useAwaitableModal from "hooks/useAwaitableModal";
import {FC} from "react";
import EditPassword from "./modals/EditPassword";
import ChangeableProfilePicture from "components/ChangeableProfilePicture";
import useAdmin from "contexts/User/useAdmin";

const ProfilePage: FC = () => {
  const user = useAdmin();
  const [editPassword, EditPasswordModal] = useAwaitableModal(EditPassword, {} as any);

  const onEditPassword = () => {
    editPassword({})
      .then(() => {})
      .catch(() => {});
  };

  return (
    <div className="w-full h-full overflow-hidden flex flex-col bg-brand-surface">
      {EditPasswordModal}
      <div className="flex-1 overflow-y-auto p-5">
        <div className="max-w-2xl mx-auto flex flex-col gap-4">
          <h1 className="text-2xl font-bold text-brand-navy">Admin Profile</h1>
          <div className="bg-white rounded-2xl border border-brand-border overflow-hidden divide-y divide-brand-border">
            {/* Avatar + name */}
            <div className="flex items-center gap-5 p-5">
              <ChangeableProfilePicture size={80} src={user.image} />
              <div className="flex flex-col gap-0.5 grow min-w-0">
                <span className="text-lg font-semibold text-brand-navy truncate">{user.name}</span>
                <span className="text-sm text-brand-muted">Admin</span>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-center gap-4 px-5 py-4">
              <EnvelopeIcon className="w-5 h-5 text-brand-muted shrink-0" />
              <div className="flex flex-col grow min-w-0">
                <span className="text-xs text-brand-muted">Email Address</span>
                <span className="text-sm text-brand-navy">{user.email}</span>
              </div>
            </div>

            {/* Password */}
            <div className="flex items-center gap-4 px-5 py-4">
              <LockIcon className="w-5 h-5 text-brand-muted shrink-0" />
              <div className="flex flex-col grow min-w-0">
                <span className="text-xs text-brand-muted">Password</span>
                <span className="text-sm text-brand-navy tracking-widest">••••••••••••</span>
              </div>
              <button className="btn-secondary shrink-0" onClick={onEditPassword}>
                Edit Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
